import React from 'react';

import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';
import { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { CheckboxChecked, CheckboxUnchecked } from '../../icons';
import { IconSize } from '../../icons/SvgIcon';

export interface CheckboxProps extends MuiCheckboxProps {
  checked?: boolean;
  disabled?: boolean;
  label?: string | JSX.Element;
  iconSize?: IconSize;
}

const useStyles = makeStyles(() => ({
  checkbox: {
    '& .MuiFormControlLabel-label': {
      marginBottom: 0,
    },
    '& .fd-text': {
      fontSize: '0.813rem',
      lineHeight: 1.38,
    },
  },

  fullWidth: {
    width: '100%',

    '& .MuiFormControlLabel-label': {
      width: '100%',
    },
  },
}));

export function Checkbox(props: CheckboxProps): JSX.Element {
  const {
    checked = false,
    disabled = false,
    label = '',
    iconSize = 'xs',
    ...rest
  } = props;
  const classes = useStyles();

  const formControlLabelStyle = clsx(
    classes.checkbox,
    label && classes.fullWidth,
  );

  return (
    <FormControlLabel
      className={formControlLabelStyle}
      control={
        <MuiCheckbox
          checked={checked}
          checkedIcon={<CheckboxChecked size={iconSize} />}
          color="default"
          disabled={disabled}
          icon={<CheckboxUnchecked size={iconSize} />}
          tabIndex={0}
          {...rest}
        />
      }
      label={label}
      labelPlacement="end"
    />
  );
}
